/**
 * 
 * 懒加载动态路由 
 */
function lazy(path) {

    //return  resolve => require(["@/components/" + name + ".vue"], resolve)
    return getComponetByPath(path);


}

function getComponetByPath(path) {
    for (var i = 0; i < dynamicRouter.length; i++) {
        var route = dynamicRouter[i];
        if (route.path == path) {
            return route.component;
        }
    }
}
/**
 * 路由定义
 * path跟配置里的资源标示对应,同时跟url地址对应
 */
const dynamicRouter = [
    {
        "menuName": "首页",
        "key": "501000",
        "resoure_type": "url",
        "path": "/website/home",
        "component": resolve => require(['@/views/website/home/home.vue'], resolve)
    },
    // {
    //     "menuName": "教师团队",
    //     "key": "502000",
    //     "resoure_type": "url",
    //     "path": "/user/admin",
    //     "component": resolve => require(['@/views/user/admin/admin.vue'], resolve)
    // },
    // {
    //     "menuName": "教学教材",
    //     "key": "503000",
    //     "resoure_type": "url",
    //     "path": "/user/admin",
    //     "component": resolve => require(['@/views/user/admin/admin.vue'], resolve)
    // },
    // {
    //     "menuName": "学员作品",
    //     "key": "504000",
    //     "resoure_type": "url",
    //     "path": "/user/admin",
    //     "component": resolve => require(['@/views/user/admin/admin.vue'], resolve)
    // },
    // {
    //     "menuName": "视频讲解",
    //     "key": "505000",
    //     "resoure_type": "url",
    //     "path": "/user/admin",
    //     "component": resolve => require(['@/views/user/admin/admin.vue'], resolve)
    // },
    // {
    //     "menuName": "校区管理",
    //     "key": "506000",
    //     "resoure_type": "url",
    //     "path": "/user/admin",
    //     "component": resolve => require(['@/views/user/admin/admin.vue'], resolve)
    // },
    // {
    //     "menuName": "用户详情",
    //     //      "key": "10101",
    //     "resoure_type": "url",
    //     "path": "/user/details",
    //     "component": resolve => require(['@/views/user/details/details.vue'], resolve)
    // },

    {
        "menuName": "用户列表",
        "key": "301000",
        "resoure_type": "url",
        "path": "/students/list",
        "component": resolve => require(['@/views/students/list/list.vue'], resolve)
    },
    {
        "menuName": "用户详情",
        "resoure_type": "url",
        "path": "/students/details",
        "component": resolve => require(['@/views/students/details/details.vue'], resolve)
    },
    {
        "menuName": "校区",
        "key": "401000",
        "resoure_type": "url",
        "path": "/school",
        "component": resolve => require(['@/views/school/school.vue'], resolve)
    },
    {
        "menuName": "课程列表",
        "key": "501000",
        "resoure_type": "url",
        "path": "/class/list",
        "component": resolve => require(['@/views/class/list/list.vue'], resolve)
    },
    {
        "menuName": "校区配置",
        "resoure_type": "url",
        "path": "/class/details",
        "component": resolve => require(['@/views/class/details/details.vue'], resolve)
    },
    {
        "menuName": "排课列表",
        "key": "502000",
        "resoure_type": "url",
        "path": "/class/paike",
        "component": resolve => require(['@/views/class/paike/paike.vue'], resolve)
    },
    {
        "menuName": "排课学员",
        "resoure_type": "url",
        "path": "/class/paikedetails",
        "component": resolve => require(['@/views/class/paikedetails/details.vue'], resolve)
    },
    {
        "menuName": "学生作业",
        "key": "503000",
        "resoure_type": "url",
        "path": "/class/zuoye",
        "component": resolve => require(['@/views/class/zuoye/zuoye.vue'], resolve)
    },
    {
        "menuName": "作业详情",
        "resoure_type": "url",
        "path": "/class/zuoyedetails",
        "component": resolve => require(['@/views/class/zuoyedetails/zuoyedetails.vue'], resolve)
    }, {
        "menuName": "试听报名",
        "key": "504000",
        "resoure_type": "url",
        "path": "/class/shiting",
        "component": resolve => require(['@/views/class/shiting/shiting.vue'], resolve)
    },
    {
        "menuName": "1499活动",
        "key": "801000",
        "resoure_type": "url",
        "path": "/class/youhui",
        "component": resolve => require(['@/views/class/youhui/youhui.vue'], resolve)
    },
    {
        "menuName": "管理员",
        "key": "101000",
        "resoure_type": "url",
        "path": "/manager/list",
        "component": resolve => require(['@/views/manager/list/list.vue'], resolve)
    },
    {
        "menuName": "角色列表",
        "key": "102000",
        "resoure_type": "url",
        "path": "/manager/role",
        "component": resolve => require(['@/views/manager/role/role.vue'], resolve)
    },
    {
        "menuName": "轮播图",
        "key": "601000",
        "resoure_type": "url",
        "path": "/userSet/banner",
        "component": resolve => require(['@/views/userSet/banner/banner.vue'], resolve)
    },
    {
        "menuName": "教师配置",
        "key": "602000",
        "resoure_type": "url",
        "path": "/userSet/teacher",
        "component": resolve => require(['@/views/userSet/teacher/teacher.vue'], resolve)
    },
    {
        "menuName": "学员作品",
        "key": "603000",
        "resoure_type": "url",
        "path": "/userSet/student",
        "component": resolve => require(['@/views/userSet/student/student.vue'], resolve)
    },
    {
        "menuName": "消课统计",
        "key": "701000",
        "resoure_type": "url",
        "path": "/tongji/xiaoke",
        "component": resolve => require(['@/views/tongji/xiaoke/xiaoke.vue'], resolve)
    },
    {
        "menuName": "订单统计",
        "key": "702000",
        "resoure_type": "url",
        "path": "/tongji/dindan",
        "component": resolve => require(['@/views/tongji/dindan/dindan.vue'], resolve)
    },
    {
        "menuName": "作业统计",
        "key": "703000",
        "resoure_type": "url",
        "path": "/tongji/zuoye",
        "component": resolve => require(['@/views/tongji/zuoye/zuoye.vue'], resolve)
    },
]
export { lazy }


// WEBPACK FOOTER //
// ./src/store/components/lazyLoading.js